import styled from 'styled-components'

const ConditionParagraph = styled.div`
  margin-top: 10px;
`

export default ConditionParagraph
